module.exports = __webpack_public_path__ + "img/blue.8309a58d.png";